export const INIT = 'INIT';
export const PENDING = 'PENDING';
export const GRANT = 'GRANT';
export const DENY = 'DENY';
